export var CardColumns;
(function (CardColumns) {
    CardColumns["One"] = "1";
    CardColumns["Two"] = "2";
    CardColumns["Three"] = "3";
    CardColumns["Four"] = "4";
})(CardColumns || (CardColumns = {}));
export var CardTextAlign;
(function (CardTextAlign) {
    CardTextAlign["Left"] = "left";
    CardTextAlign["Center"] = "center";
    CardTextAlign["Right"] = "right";
})(CardTextAlign || (CardTextAlign = {}));
export var CardPaddingSize;
(function (CardPaddingSize) {
    CardPaddingSize["Large"] = "L";
    CardPaddingSize["Medium"] = "M";
    CardPaddingSize["Small"] = "S";
    CardPaddingSize["ExtraSmall"] = "Xs";
})(CardPaddingSize || (CardPaddingSize = {}));
export var ImageLayoutType;
(function (ImageLayoutType) {
    ImageLayoutType["ImageSizeS"] = "ImageSizeS";
    ImageLayoutType["ImageSizeM"] = "ImageSizeM";
    ImageLayoutType["ImageSizeL"] = "ImageSizeL";
    ImageLayoutType["ImageCoverTop"] = "ImageCoverTop";
    ImageLayoutType["ImageContainTop"] = "ImageContainTop";
    ImageLayoutType["ImageContainTopFullWidth"] = "ImageContainTopFullWidth";
})(ImageLayoutType || (ImageLayoutType = {}));
export const convertCardColumnsToCardSize = (columns) => {
    if (columns === CardColumns.Four) {
        return CardPaddingSize.Small;
    }
    else if (columns === CardColumns.Three) {
        return CardPaddingSize.Medium;
    }
    else {
        return CardPaddingSize.Large;
    }
};
//# sourceMappingURL=card.js.map